export default __webpack_public_path__ + "static/media/theme4.5d029513.jpg";